export const comments_5187257 = {"data":{"data":[],"links":{}}}